import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// ✅ SAME NAV (copied from dashboard)
const NAV = [
  { icon: '⬡', label: 'Dashboard', path: '/dashboard' },
  { icon: '👥', label: 'User Management', path: '/user-management' },

  {
    icon: '🌤️',
    label: 'Season Details',
    children: [
      { icon: '🌤️', label: 'Season Name', path: '/season-name' },
      { icon: '📅', label: 'Season Duration', path: '/season-duration' }
    ]
  },

  { icon:'⏱️', label:'Rent Durations', path:'/rent-durations' },

  {
    icon: '🚗',
    label: 'Manage Car/Vehicle',
    children: [
      { icon: '🚗', label: 'Car Group', path: '/cargroup' },
      { icon: '🚘',  label: 'Manage Cars',     path: '/manage-cars' },
      {icon:'💰', label:'Car Price',       path:'/car-price'},
      {icon:'💰', label:'Transfer Price',       path:'/transfer-price'},
      {icon:'🚘', label:'Stop Sale',       path:'/stop-sale'},
      {icon:'💰', label:'Boost Price',       path:'/boost-price'},
      {icon:'💰', label:'Manage Promotional Price',       path:'/promotional-price'},
      {icon:'💰', label:'Manage Weekend Rate',       path:'/weekend-rate'},
      
    ]
  },

  {
    icon: '🚘',
    label: 'Fleet Management',
    children: [
      { icon: '🧑‍💼', label: 'Cab Owner Details', path: '/cab-owner-details' },
      { icon: '🚘',  label: 'Driver Details',     path: '/driver-details' },
      {icon:'💰', label:'Individual Fleet Details',       path:'/cab-details'},
    ]
  },

  {
    icon: '🚕',
    label: 'Manage Leasing',
    children: [
      { icon: '🚖', label: 'Leasing Car Details', path: '/leasing-cars' },
      { icon: '📝',  label: 'Leasing Page Content',     path: '/page-content' },
      {icon:'🚘', label:'Leasing Inquiries',       path:'/manage-leasinginq'},
    ]
  },

  { icon: '💳', label: 'Manage Coupon Code', path: '/coupon-code' },
  {
    icon: '🚕',
    label: 'Manage Locations',
    children: [
      { icon: '🚖', label: 'City Name', path: '/manage-city' },
      { icon: '📝',  label: 'Location Name',     path: '/manage-location' },
    ]
  },
  {
    icon: '🚕',
    label: 'Manage Optional Items',
    children: [
      { icon: '📝', label: 'Optional Extra Item names', path: '/manage-optionalextra' },
      { icon: '🔧', label: 'Optional Extra Details', path: '/optional-extra-detail' },
      {icon:'🛡️',  label:'Insurance Day Slab', path:'/insurance-day-slab'},
      { icon: '🛡️', label: 'Insurance Details', path: '/insurance-detail' },
    ]
  },
  
  { icon: '📋', label: 'Manage Delay Charge', path: '/manage-delaycharge' },

  {
    icon: '🔧',
    label: 'Default Settings',
    children: [
      { icon: '📝', label: 'Night Delivery', path: '/manage-nightdelivery' },
      { icon: '🔧', label: 'Page Master', path: '/manage-pagemaster' },
      {icon:'🛡️',  label:'Parameters', path:'/manage-setting'},
      { icon: '💳', label: 'Default Section', path: '/manage-section' },
      { icon: '🔧', label: 'Booking Engine', path: '/manage-booking-engine' },
    ]
  },

  { icon: '👤', label: 'Manage FAQ', path: '/manage-faqs' },
  { icon: '📋', label: 'Manage Online Bookings', path: '/manage-bookings' },
  { icon: '🚘', label: 'Manage Transfer Bookings', path: '/manage-transferbooking' },
  { icon: '📜', label: 'Manage Rent Agreement', path: '/manage-contracts' },
  { icon: '🚘', label: 'Manage Inquiry', path: '/manag-inquiry' },
  { icon: '🚗', label: 'Manage Request', path: '/manage-request' },
  { icon: '🖼️', label: 'Manage Banners', path: '/manage-banners' },
  { icon: '📝', label: 'Manage Attraction', path: '/manage-attraction' },
  { icon: '👤', label: 'Manage Testimonial', path: '/manage-testimonial' },
  { icon: '🖼️', label: 'Manage Gallery', path: '/manage-gallery' },
  { icon: '🚘', label: 'Manage Content', path: '/manage-content' },
  { icon: '👤', label: 'Manage SEO', path: '/manage-seo' },
  { icon: '💳', label: 'Change Password', path: '/change-password' },
];

// export default function Layout({ children, activePage }) {
//   const navigate = useNavigate();

//   const [sideOpen, setSideOpen] = useState(true);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [user, setUser] = useState(null);
//   const location = useLocation();

//   useEffect(() => {
//     setUser(JSON.parse(localStorage.getItem('user')));
//   }, []);

// REPLACE WITH
// Mapping from mod_id → route paths it controls
// REPLACE WITH
const MOD_PATH_MAP = {
  3:  ['/season-name', '/season-duration'],                           // Period
  4:  ['/cargroup', '/manage-cars', '/car-price', '/transfer-price',  // Car
        '/stop-sale', '/boost-price', '/promotional-price', '/weekend-rate'],
  5:  ['/manage-city', '/manage-location'],                           // Location Details
  6:  ['/manage-optionalextra', '/optional-extra-detail',             // Optional Extras
        '/insurance-day-slab', '/insurance-detail'],
  10: ['/manage-faqs'],                                               // FAQ
  11: ['/manage-bookings', '/manage-transferbooking'],                // Manage Online Booking
  12: ['/manage-seo'],                                                // SEO
  13: ['/rent-durations'],                                            // Rent Duration
  14: ['/user-management'],                                           // User Management
  15: ['/cab-owner-details', '/driver-details', '/cab-details'],      // Fleet Management
  16: ['/leasing-cars', '/page-content', '/manage-leasinginq'],       // Manage Leasing
  17: ['/coupon-code'],                                               // Coupon Code
  18: ['/manage-delaycharge'],                                        // Delay Charge
  19: ['/manage-nightdelivery', '/manage-pagemaster',                 // Default Settings
        '/manage-setting', '/manage-section', '/manage-booking-engine'],
  20: ['/manage-banners'],                                            // Manage Banners
  21: ['/manage-attraction'],                                         // Manage Attractions
  22: ['/manage-testimonial'],                                        // Manage Testimonial
  23: ['/manage-gallery'],                                            // Manage Gallery
  24: ['/manage-content'],                                            // Manage Content
  25: ['/manag-inquiry'],                                             // Manage Inquiry
  26: ['/manage-request'],                                            // Manage Request
  27: ['/manage-contracts'],                                          // Rent Agreement
};

function getAccessiblePaths(mod_ids) {
  if (!mod_ids || mod_ids.length === 0) return new Set();
  const paths = new Set();
  mod_ids.forEach(mid => {
    (MOD_PATH_MAP[mid] || []).forEach(p => paths.add(p));
  });
  return paths;
}

function filterNav(nav, accessiblePaths, isAdmin) {
  if (isAdmin) return nav; // admin sees everything
  return nav
    .map(item => {
      if (item.children) {
        const filteredChildren = item.children.filter(c => accessiblePaths.has(c.path));
        if (filteredChildren.length === 0) return null;
        return { ...item, children: filteredChildren };
      }
      // Always show Dashboard and Change Password to everyone
      if (item.path === '/dashboard' || item.path === '/change-password') return item;
      return accessiblePaths.has(item.path) ? item : null;
    })
    .filter(Boolean);
}

export default function Layout({ children, activePage }) {
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(true);
  const [openMenu, setOpenMenu] = useState(null);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navRef = useRef(null);
const isRestoringRef = useRef(false); // ← blocks false saves during restore

useEffect(() => {
  setUser(JSON.parse(localStorage.getItem('user')));
}, []);

useEffect(() => {
  const nav = navRef.current;
  if (!nav) return;
  const saved = sessionStorage.getItem('sidebarScrollTop');
  if (saved) {
    isRestoringRef.current = true; // block scroll saves
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        nav.scrollTop = parseInt(saved, 10);
        // Allow saves again after restore settles
        setTimeout(() => { isRestoringRef.current = false; }, 100);
      });
    });
  }
}, [location.pathname]);

useEffect(() => {
  const nav = navRef.current;
  if (!nav) return;
  const onScroll = () => {
    if (isRestoringRef.current) return; // ← ignore scroll during restore
    sessionStorage.setItem('sidebarScrollTop', nav.scrollTop);
  };
  nav.addEventListener('scroll', onScroll);
  return () => nav.removeEventListener('scroll', onScroll);
}, []);

  useEffect(() => {
    NAV.forEach(n => {
      if (n.children) {
        n.children.forEach(c => {
          if (c.path === location.pathname) {
            setOpenMenu(n.label);
          }
        });
      }
    });
  }, [location.pathname]);

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };



  return (
    <>
    <style>{SCROLL_STYLE}</style>

    <div style={S.root}>

      {/* ─── Sidebar ─── */}
      <aside style={{ ...S.sidebar, width: sideOpen ? 245 : 68 }}>

        {/* Top */}
        <div style={S.sideTop}>
          <div style={S.logoWrap}>
            <div style={S.logoIcon}>🚗</div>
            {sideOpen && <span style={S.logoText}>Orisys</span>}
          </div>

          <button style={S.collapseBtn} onClick={() => setSideOpen(p => !p)}>
            {sideOpen ? '◀' : '▶'}
          </button>
        </div>

        {/* Menu */}
        {/* <nav style={{...S.nav, flex: 1 }}>
          {NAV.map((n, i) => ( */}
         
        {/* <nav style={{...S.nav, flex: 1 }}> */}
        <nav ref={navRef} style={{...S.nav, flex: 1 }}>
          {(() => {
            const isAdmin = user?.user_type === 1;
            const accessiblePaths = getAccessiblePaths(user?.mod_ids);
            const filteredNav = filterNav(NAV, accessiblePaths, isAdmin);
            return filteredNav;
          })().map((n, i) => (
            <div key={i}>

              {/* Parent */}
              <div
                style={{
                  ...S.navItem,
                  // ...(activePage === n.label ? S.navActive : {})
                  ...( 
                    location.pathname === n.path ||
                    (n.children && n.children.some(c => c.path === location.pathname))
                      ? S.navActive
                      : {}
                  )
                }}
                onClick={() => {
                  if (n.children) {
                    setOpenMenu(openMenu === n.label ? null : n.label);
                  } else {
                    navigate(n.path);
                  }
                }}
              >
                <span style={S.navIcon}>{n.icon}</span>

                {sideOpen && (
                  <>
                    <span style={S.navLabel}>{n.label}</span>
                    {n.children && (
                      <span style={{ marginLeft: 'auto' }}>
                        {openMenu === n.label ? '▲' : '▼'}
                      </span>
                    )}
                  </>
                )}
              </div>

              {/* Children */}
              {n.children && openMenu === n.label && (
                <div
                className="submenu-scroll"
                
              >
                 {n.children.map((c, j) => (
  <div
    key={j}
    style={{
      ...S.navItem,
      ...(location.pathname === c.path ? S.navActive : {})
    }}
    onClick={() => navigate(c.path)}
  >
                      <span style={S.navIcon}>{c.icon}</span>
                      {sideOpen && <span style={S.navLabel}>{c.label}</span>}
                    </div>
                  ))}
                </div>
              )}

            </div>
          ))}
        </nav>

        {/* Bottom */}
        <div style={S.sideBottom}>
          {sideOpen && (
            <div style={S.userChip}>
              <div style={S.avatar}>{user?.user_name?.[0] || 'A'}</div>
              <div>
                <div style={S.userName}>{user?.user_name || 'Admin'}</div>
                <div style={S.userRole}>Administrator</div>
              </div>
            </div>
          )}

          <button style={S.logoutBtn} onClick={logout}>
            🚪 {sideOpen && 'Logout'}
          </button>
        </div>
      </aside>

      {/* ─── Main Content ─── */}
      <main style={{ ...S.main, marginLeft: sideOpen ? 245 : 68 }}>
        {children}
      </main>

    </div>
    </>
  );
}





const SCROLL_STYLE = `
.submenu-scroll {
  scrollbar-width: thin;
  background:#000;
}

.submenu-scroll::-webkit-scrollbar {
  width: 5px;   /* ✅ reduced from 6px */
}


.submenu-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.submenu-scroll::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.3);
  border-radius: 10px;
}

.submenu-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,0.5);
}

aside::-webkit-scrollbar {
  width: 5px;
}

aside::-webkit-scrollbar-track {
  background: transparent;
}

aside::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.25);
  border-radius: 10px;
}

`;

/* 🎨 SAME STYLE FROM DASHBOARD */
const S = {
  root:{ display:'flex', minHeight:'100vh', background:'#f4f6fb' },

  // sidebar:{ background:'#1a1d2e', color:'#fff', display:'flex', flexDirection:'column',
  //   position:'fixed', height:'100vh', transition:'width 0.25s', overflow:'scroll' },
    
    sidebar:{
      background:'#1a1d2e',
      color:'#fff',
      display:'flex',
      flexDirection:'column',
      position:'fixed',
      height:'100vh',
      transition:'width 0.25s',
    
      overflowY:'auto',   // ✅ only vertical scroll
      overflowX:'hidden', // ✅ prevent horizontal scroll
      paddingRight:'6px'  // ✅ space for scrollbar
    },


  sideTop:{ display:'flex', justifyContent:'space-between', padding:'20px 16px' },

  logoWrap:{ display:'flex', gap:10 },
  logoIcon:{ width:36, height:36, background:'linear-gradient(135deg,#6C63FF,#43BCCD)',
    borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center' },
  logoText:{ fontWeight:800 },

  collapseBtn:{ background:'rgba(255,255,255,0.08)', border:'none', color:'#aaa', cursor:'pointer' },
  // nav:{ height:'70vh',overflowY:'scroll'},
  nav:{ height:'70vh', overflowY:'auto'},

  navItem: {
    display:'flex', alignItems:'center', gap:12,
    paddingTop:'11px', paddingBottom:'11px', paddingLeft:'16px', paddingRight:'16px',  // ✅ explicit
    cursor:'pointer', borderRadius:10, margin:'2px 10px',
    color:'#aaa', fontSize:14, transition:'all 0.15s', whiteSpace:'nowrap'
  },
  navActive: {
    background:'rgba(99,179,237,0.12)', color:'#63b3ed',
    borderLeft:'3px solid #63b3ed',
    paddingLeft:'13px'   // ✅ now no conflict since navItem uses explicit padding too
  },
  
  navIcon:{ fontSize:16 },
  navLabel:{ fontWeight:500 },

  sideBottom:{ padding:16 },

  userChip:{ display:'flex', gap:10, marginBottom:12 },
  avatar:{ width:36, height:36, background:'#6C63FF', borderRadius:'50%',
    display:'flex', alignItems:'center', justifyContent:'center' },

  userName:{ fontSize:13, fontWeight:700 },
  userRole:{ fontSize:11, color:'#777' },

  logoutBtn:{ width:'100%', padding:10, background:'#ff6b6b22',
    border:'1px solid #ff6b6b33', color:'#ff6b6b', borderRadius:8 },

  main:{ flex:1, padding:20, transition:'margin-left 0.25s',width:'66%' }
};